module.exports = __webpack_public_path__ + "img/checked.c8a6670d.svg";